/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_SlovenianInputs */



/**
* | output |
* | --- |
* | "Slovenian" |
*
* @param {Speechmatics_Target_Language_SlovenianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_slovenian = /** @type {((inputs?: Speechmatics_Target_Language_SlovenianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_SlovenianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Slovene")
	if (locale === "de") return /** @type {LocalizedString} */ ("Slowenisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("sloveno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("словенский")
	if (locale === "es") return /** @type {LocalizedString} */ ("esloveno")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("斯洛文尼亚语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スロベニア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्लोवेनियाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("esloveno")
	return /** @type {LocalizedString} */ ("Slovenian")
});